import { memo } from 'react'
import { Badge } from '@/components/ui/badge'
import { usePricingResolution } from '@/hooks/usePricing'
import { PRICING_SOURCE_LABELS, type PricingSource } from '@/types/pricing'

const SOURCE_VARIANT: Record<PricingSource, string> = {
  policy: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  contract: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  manual: 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200',
  override: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200',
  dynamic: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
}

interface PricingSourceBadgeProps {
  locationId: string
  catalogItemCode: string
  aircraftId?: string
  clientId?: string
}

export const PricingSourceBadge = memo(function PricingSourceBadge({
  locationId,
  catalogItemCode,
  aircraftId,
  clientId,
}: PricingSourceBadgeProps) {
  const { data: resolution } = usePricingResolution(
    locationId
      ? {
          locationId,
          catalogItemCode,
          aircraftId,
          clientId,
        }
      : null
  )

  if (!resolution || resolution.unit_price == null) return null

  return (
    <Badge
      variant="secondary"
      className={`text-[10px] px-1.5 py-0 h-5 ${SOURCE_VARIANT[resolution.source] ?? ''}`}
    >
      ${Number(resolution.unit_price).toFixed(2)} {PRICING_SOURCE_LABELS[resolution.source]}
    </Badge>
  )
})
